/**
 * Created by zzy on 2019/8/1.
 */
export default {
  name: 'MonitoringDevice',
  data () {
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/views/assets/monitoringDevice/MonitoringDevice.js